import { array, mixed, number, object, string } from 'yup';

export const createSchema = object({
	hero_banner_toolkit: object().shape({
		headline: string()
			.required('This is a required field')
			.test('not-empty-html', 'This is a required field', function (value) {
				if (!value) return false;
				// Remove HTML tags and check if there's actual text content
				const textContent = value.replace(/<[^>]*>/g, '').trim();
				return textContent.length > 0;
			}),
		image: mixed(),
	}),
	how_to_use_section_toolkit: object().shape({
		name: string().required('This is a required field'),
		headline: string()
			.required('This is a required field')
			.test('not-empty-html', 'This is a required field', function (value) {
				if (!value) return false;
				const textContent = value.replace(/<[^>]*>/g, '').trim();
				return textContent.length > 0;
			}),
		body: string()
			.required('This is a required field')
			.test('not-empty-html', 'This is a required field', function (value) {
				if (!value) return false;
				const textContent = value.replace(/<[^>]*>/g, '').trim();
				return textContent.length > 0;
			}),
		button: string().required('This is a required field'),
		steps: array()
			.of(
				object().shape({
					title: string().required('Step title is required'),
					description: string()
						.required('Step description is required')
						.test('not-empty-html', 'Step description is required', function (value) {
							if (!value) return false;
							const textContent = value.replace(/<[^>]*>/g, '').trim();
							return textContent.length > 0;
						}),
					image: mixed(),
				})
			)
			.min(1, 'At least one step is required')
			.required('Steps are required'),
	}),
	objectives_section_toolkit: object().shape({
		name: string().required('This is a required field'),
		headline: string()
			.required('This is a required field')
			.test('not-empty-html', 'This is a required field', function (value) {
				if (!value) return false;
				const textContent = value.replace(/<[^>]*>/g, '').trim();
				return textContent.length > 0;
			}),
		objectives: array()
			.of(
				object().shape({
					title: string().required('Objective title is required'),
					description: string()
						.required('Objective description is required')
						.test('not-empty-html', 'Objective description is required', function (value) {
							if (!value) return false;
							const textContent = value.replace(/<[^>]*>/g, '').trim();
							return textContent.length > 0;
						}),
					image: mixed(),
				})
			)
			.min(1, 'At least one objective is required')
			.required('Objectives are required'),
	}),
	where_does_the_toolkit_fit_section_toolkit: object().shape({
		name: string().required('This is a required field'),
		headline: string()
			.required('This is a required field')
			.test('not-empty-html', 'This is a required field', function (value) {
				if (!value) return false;
				const textContent = value.replace(/<[^>]*>/g, '').trim();
				return textContent.length > 0;
			}),
		body: string()
			.required('This is a required field')
			.test('not-empty-html', 'This is a required field', function (value) {
				if (!value) return false;
				const textContent = value.replace(/<[^>]*>/g, '').trim();
				return textContent.length > 0;
			}),
		phrases: array()
			.of(
				object().shape({
					content: string().required('Phrase content is required'),
					color: string().required('Phrase color is required'),
					scale: number()
						.min(1, 'Scale must be at least 1')
						.max(1.3, 'Scale must be at most 1.3')
						.required('Scale is required'),
					z_index: number().min(0).max(100).required('Overlap priority is required'),
				})
			)
			.min(1, 'At least one phrase is required')
			.required('Phrases are required'),
	}),
});
